import settings from '@/config/settings';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

const url = new URL(settings.SERVICES.BACKEND.URL + '/role/sync');

export const roleSyncAPI = useAPIHook(url);
